import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CookieConsent from "@/components/CookieConsent";
import Home from "@/pages/Home";
import Reviews from "@/pages/Reviews";
import ReviewDetail from "@/pages/ReviewDetail";
import Compare from "@/pages/Compare";
import Blog from "@/pages/Blog";
import BlogDetail from "@/pages/BlogDetail";
import FAQ from "@/pages/FAQ";
import Security from "@/pages/Security";
import Contact from "@/pages/Contact";
import About from "@/pages/About";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Disclaimer from "@/pages/Disclaimer";
import NotFound from "@/pages/NotFound";
import { Toaster } from "@/components/ui/sonner";
import { trackContactConversion } from "@/lib/tracking";

function App() {
    // Fire Google Ads "Contact" conversion on any tel: link click, site-wide
    useEffect(() => {
        const onClick = (e) => {
            const anchor = e.target.closest && e.target.closest('a[href^="tel:"]');
            if (!anchor) return;
            trackContactConversion({
                event_category: "phone",
                event_label: anchor.getAttribute("data-testid") || "tel-link",
            });
        };
        document.addEventListener("click", onClick, true);
        return () => document.removeEventListener("click", onClick, true);
    }, []);

    return (
        <div className="App min-h-screen flex flex-col">
            <BrowserRouter>
                <Header />
                <main className="flex-1">
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/reviews" element={<Reviews />} />
                        <Route path="/reviews/:slug" element={<ReviewDetail />} />
                        <Route path="/compare" element={<Compare />} />
                        <Route path="/blog" element={<Blog />} />
                        <Route path="/blog/:slug" element={<BlogDetail />} />
                        <Route path="/faq" element={<FAQ />} />
                        <Route path="/security" element={<Security />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/privacy" element={<Privacy />} />
                        <Route path="/terms" element={<Terms />} />
                        <Route path="/disclaimer" element={<Disclaimer />} />
                        <Route path="*" element={<NotFound />} />
                    </Routes>
                </main>
                <Footer />
                <CookieConsent />
                <Toaster position="top-right" theme="dark" />
            </BrowserRouter>
        </div>
    );
}

export default App;
